var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.node.id)+". "+_vm._s(_vm.node.text))]),(_vm.node.children && _vm.node.children.length)?_c('ul',_vm._l((_vm.node.children),function(child,index){return _c('ripa-node-tree',{key:index,attrs:{"node":child}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }